import { createAction, props } from '@ngrx/store';
import { Point } from '../../../tracks/models/point';
import { PointsParams } from '../../../tracks/models/points-params';
import { PointsSummary } from '../../../tracks/models/points-summary';

export const getPointsSuccess = createAction(
  '[Points/API] Get Points Success',
  props<{params: PointsParams, data: PointsSummary[], unitIds?: number[]}>()
);

export const getPointsFailure = createAction(
  '[Points/API] Get Points Failure',
  props<{error: any}>()
);

export type PointsApiActionsUnion = ReturnType<
  typeof getPointsSuccess |
  typeof getPointsFailure
  >;
